routing.$inject = ['$urlRouterProvider', '$locationProvider'];


export default function routing($urlRouterProvider, $locationProvider) {
    $urlRouterProvider.otherwise('/');
    $locationProvider.html5Mode(true);
    
}


// WEBPACK FOOTER //
// ./app/config/routing.js